import { formatPrice } from "@utils/units";

export const useFormatPrice = (
  price: number,
  options?: {
    locale?: string;
    currency?: string;
  },
): string => {
  return formatPrice(price, options);
};
